import { Alert, Link, Stack, Typography } from '@mui/material';
import type { StravaAccount } from 'core';
import type { FC } from 'react';
import { StravaAccountHeader } from './strava-account-header.js';

interface Props {
  account?: StravaAccount;
  onForgetAccountClick: () => void;
  onOnlyRunsChanged: () => void;
  onlyRuns: boolean;
}

export const NoItemsView: FC<Props> = ({
  account,
  onForgetAccountClick,
  onOnlyRunsChanged,
  onlyRuns,
}) => (
  <Stack spacing={3}>
    <StravaAccountHeader
      account={account}
      onForgetAccountClick={onForgetAccountClick}
      onOnlyRunsChanged={onOnlyRunsChanged}
      onlyRuns={onlyRuns}
    />
    <Typography variant="body2" color="text.secondary" fontStyle="italic">
      No activities could be found on Strava.
    </Typography>
    {account?.activityAccess === 'none' ? (
      <Alert severity="warning">
        OTrax is connected to Strava, but activity access was not granted.
        Reconnect your account and allow activity access to import activities.
      </Alert>
    ) : null}
    {account?.activityAccess === 'public' ? (
      <Alert severity="info">
        OTrax can only read public Strava activities for this account. Private
        activities will not appear unless private activity access is allowed.
      </Alert>
    ) : null}
    {onlyRuns && (
      <Typography variant="body2" color="text.secondary">
        Try looking for activities that weren't created as "Runs" in Strave by
        adjusting the toggle.
      </Typography>
    )}
    <Typography variant="body2" color="text.secondary">
      Check that your activities are marked as visible to "Everyone" in Strava.
      <ul>
        <li>
          <Link href="https://support.strava.com/hc/en-us/articles/216919377">
            Learn More
          </Link>
        </li>
        <li>
          <Link href="https://www.strava.com/settings/privacy">
            Strava Privacy Settings
          </Link>
        </li>
      </ul>
    </Typography>
  </Stack>
);
